import React, { useMemo } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { PubNubProvider } from 'pubnub-react';
import PubNub from 'pubnub';

function ProtectedRoutes() {
  const { user } = useAuth();
  const pubnub = useMemo(() => {
    return new PubNub({
      publishKey: process.env.REACT_APP_PUBNUB_PUBLISH_KEY,
      subscribeKey: process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY,
      userId: String(user?.id) || '',
    });
  }, [user?.id]);
  if (user) {
    return (
      <PubNubProvider client={pubnub}>
        <Outlet />
      </PubNubProvider>
    );
  }
  return <Navigate to="/" />;
}

export default ProtectedRoutes;
